import { Package } from "./package.model";
import { PackageTypePolicy, Policy } from "./policy.model";

export class Admin {
    [key: string | number]: any;
    show?: boolean;
    schemma: any = [
        {
            target: 'packages',
            routes: [
                { target: 'multi upgrade', route: '/admin-tools/packages/upgrade' }
            ]
        }
    ];
    persistance?: AdminPersistance = {}
    packages: AdminPackages = {
        refreshEnable: {
            every: true,
            assigned: true,
            test: true,
            active: true,
            inactiveRequest: true,
            inactive: true,
            inUpgrade: true,
        },
        totalsByStatus: {
            assigned: 0,
            test: 0,
            active: 0,
            inactiveRequest: 0,
            inactive: 0,
            inUpgrade: 0,
        },
        statusSelection: {
            assigned: false,
            test: false,
            active: false,
            inactiveRequest: false,
            inactive: false,
            inUpgrade: false,
        },
        statusToogle: {
            assigned: false,
            test: false,
            active: false,
            inactiveRequest: false,
            inactive: false,
            inUpgrade: false,
        },
        collection: [],
        modStatus: {
            totals: {
                assigned: 0,
                test: 0,
                active: 0,
                inactiveRequest: 0,
                inactive: 0,
                inUpgrade: 0
            },
            done: {
                assigned: 0,
                test: 0,
                active: 0,
                inactiveRequest: 0,
                inactive: 0,
                inUpgrade: 0
            }
        },
        actionFocused: null,
        statusFocused: null,
        dataFocused: null,
        actionStatus: 'NONE'
    };
    bgProcesses: AdminBgProcesses = {
        visible: false,
        packages: [
            {
                name: 'MODIFYINGPACKAGES',
                status: 'PENDING',
                errorMsg: null,
                data: null,
                target: null,
                from: null,
                to: null
            }
        ]
    };
}

export class AdminModalConfig {
    [key: string | number]: any;
    status?: string | null;
    actionFocused?: string | null;
    actionStatus?: string | null;
    head?: string | null;
    head5?: string | null;
    message?: string | null;
    extendedMessage?: string | null;
    hideConfirm?: boolean;
    hideCancel?:boolean;
    confirmText?: string | null;
    cancelText?: string | null;
    packageFocusedId?: number | null;
    data: any;
}

export class AdminPersistance {
    [key: string | number]: any;
    aUPAentitiesListSelectedApplied?: any;//admin Update Packages Automatization entities list applied
    aUPAentitiesListSelected?: any;//admin Update Packages Automatization entities list selected
}

export class AdminPackages {
    [key: string | number]: any;
    entities?: number[];
    distEntityIdFocused?:number;
    distPolicies?:PackageTypePolicy[];
    type?: number;
    newType?: number;
    category?: number;
    refreshEnable?: AdminPackagesRefreshEnable;
    totalsByStatus?: AdminPackagesTotalsByStatus;
    statusSelection?: AdminStatusSelection;
    statusToogle?: AdminStatusToogle;
    collection?: AdminPackagesCollection;
    modStatus?: AdminPackagesModStatus;
    actionFocused?: string | null;//action focused
    actionStatus?: any;//action status NONE|INPROGRESS|CANCELED|END
    statusFocused?: string | null;//status focused while modifying
    dataFocused?: any;//data focused while action

}

export class AdminPackagesRefreshEnable {
    [key: string | number]: any;
    every?: boolean;
    assigned?: boolean;
    test?: boolean;
    active?: boolean;
    inactiveRequest?: boolean;
    inactive?: boolean;
    inUpgrade?: boolean;
}

export class AdminPackagesTotalsByStatus {
    [key: string | number]: any;
    assigned?: number;
    test?: number;
    active?: number;
    inactiveRequest?: number;
    inactive?: number;
    inUpgrade?: number;
}

export class AdminStatusSelection {
    [key: string | number]: any;
    assigned?: boolean;
    test?: boolean;
    active?: boolean;
    inactiveRequest?: boolean;
    inactive?: boolean;
    inUpgrade?: boolean;
}

export class AdminStatusToogle {
    [key: string | number]: any;
    assigned?: boolean;
    test?: boolean;
    active?: boolean;
    inactiveRequest?: boolean;
    inactive?: boolean;
    inUpgrade?: boolean;
}


export class AdminPackagesCollection {
    [key: string | number]: any;
    assigned?: Package[] = [];
    test?: Package[] = [];
    active?: Package[] = [];
    inactiveRequest?: Package[] = [];
    inactive?: Package[] = [];
    inUpgrade?: Package[] = [];
}

export class AdminPackagesModStatus {
    [key: string | number]: any;
    totals?: { [key: string | number]: number };
    done?: { [key: string | number]: number };

}

export class AdminBgProcesses {
    [key: string | number]: any;
    visible?: boolean;
    packages?: any[];
}
export class AdminBgProcess {
    [key: string | number]: any;
    name?: string;
    status?: string;
    errorMsgc?: string | null;
}
export class AdminBgProcessModiying {
    [key: string | number]: any;
    name?: string;
    status?: string;
    errorMsgc?: string | null;
    target?: string | null;
    from?: number | null;
    to?: number | null;
}